module.exports = __webpack_public_path__ + "static/media/gif3.d5819ffc.gif";